import { HttpInterceptorFn, HttpContextToken } from "@angular/common/http"; // Import HttpContextToken, HttpContext
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { LoaderService } from "@core/services/loader/loader.service";
import { configuration } from "properties/config";

// Define the HttpContextToken for controlling the loader
export const SHOW_LOADER = new HttpContextToken<boolean>(() => true); // Default to true if not provided

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  // Check the context to decide whether to show the loader
  const showLoader = req.context.get(SHOW_LOADER);
  // Check if the request URL is an authentication URL
  const isAuthUrl = Object.values(configuration.authUrls).some((value) =>
    req.url.includes(value)
  );

  if (showLoader && !isAuthUrl) {
    // Only show loader if SHOW_LOADER is true in context and it's not an auth URL
    loaderService.show();
    return next(req).pipe(finalize(() => loaderService.hide()));
  } else {
    // If SHOW_LOADER is false, just proceed with the request without showing loader
    return next(req);
  }
};
